const truncateStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  padding: '4px 2px'
};

// Multi-select tabs: a promo can appear on 1..N of these.
export const TAB_OPTIONS = ['Parikramas', 'Live', 'Mantras'];

// Locked enum for INTERNAL link targets (exploreAll + card links).
// Read/Listen keys come from the mobile app's CATEGORY_MAPs, prefixed with READ_ / LISTEN_
// so the destination screen is unambiguous in admin.
export const INTERNAL_ROUTE_KEYS = [
  'DEVOTION_MENU',
  'KNOWLEDGE_MENU',
  'TEERTHAS',
  'SAINTS',
  'PROJECTS',
  'TEMPLES',
  'DEITIES',
  // Read
  'READ_MANTRAS',
  'READ_POOJA_HAVAN_VIDHIS',
  'READ_EBOOKS',
  'READ_ABOUT_TEERTHAS',
  'READ_ESSAYS_BLOGS',
  'READ_AARTIS',
  // Listen
  'LISTEN_MANTRAS_CHANTS',
  'LISTEN_STOTRA_RECITATIONS',
  'LISTEN_AARTIS',
  'LISTEN_DISCOURSES_PRAVACHANS',
  'LISTEN_AUDIOBOOKS',
  'LISTEN_BHAJANS_KIRTANS'
];

export const LINK_TYPES = ['INTERNAL', 'EXTERNAL'];
export const CARD_STATUS = ['ACTIVE', 'INACTIVE'];

export const SCROLL_SEQUENCE_MIN = 0;
export const SCROLL_SEQUENCE_MAX = 999;

export const formatDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const slugify = (str) => {
  return String(str || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40);
};

export const generateCardId = (cardName) => {
  const slug = slugify(cardName) || 'card';
  const rand = Math.random().toString(36).slice(2, 8);
  return `c_${slug}_${rand}`;
};

// Best-effort JSON parse for the tabs field returned by the backend.
// Backend stores as JSON; some drivers surface it as string, some as array.
export const normalizeTabs = (raw) => {
  if (Array.isArray(raw)) return raw;
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }
  return [];
};

export const tableColumns = [
  { name: 'ID',  selector: row => row.id, sortable: true, center: true, width: '80px', style: truncateStyle },
  {
    name: 'Section Name',
    selector: row => row.section_name,
    sortable: true,
    center: true,
    width: '220px',
    cell: row => (
      <div style={{ ...truncateStyle, color: '#5C61F2', fontWeight: 'bold', width: '100%', textAlign: 'center' }}>
        {row.section_name || <em style={{ color: '#999' }}>—</em>}
      </div>
    )
  },
  {
    name: 'Tabs',
    selector: row => row.tabs_display,
    sortable: false,
    center: true,
    width: '220px',
    cell: row => (
      <div className="d-flex flex-wrap gap-1 justify-content-center">
        {row.tabs_arr.length === 0
          ? <em style={{ color: '#999' }}>—</em>
          : row.tabs_arr.map(t => (
              <span
                key={t}
                className="badge"
                style={{
                  background: '#EEF0FF',
                  color: '#5C61F2',
                  fontSize: '10px',
                  padding: '4px 8px',
                  borderRadius: '12px'
                }}
              >
                {t}
              </span>
            ))}
      </div>
    )
  },
  { name: 'Scroll Seq', selector: row => row.scroll_sequence, sortable: true, center: true, width: '110px', style: truncateStyle },
  { name: '# Cards',    selector: row => row.card_count,      sortable: true, center: true, width: '90px',  style: truncateStyle },
  {
    name: 'Active',
    selector: row => row.active,
    sortable: true,
    center: true,
    width: '90px',
    id: 'status',
    cell: row => (
      <span
        style={{
          minWidth: '60px',
          textAlign: 'center',
          borderRadius: '20px',
          padding: '4px 8px',
          backgroundColor: row.active ? '#28a745' : '#6c757d',
          color: '#FFFFFF',
          fontSize: '10px'
        }}
      >
        {row.active ? 'ON' : 'OFF'}
      </span>
    )
  },
  { name: 'Updated On', selector: row => row.updated_on_display, sortable: true, center: true, width: '160px', style: truncateStyle },
  { name: 'Action',     selector: row => row.action,             sortable: false, center: true, width: '160px', id: 'action', style: truncateStyle }
];
